import axios from 'axios';
import config from '../config';
import { errorMessage, notifyError } from './notify';

const axiosInstance = axios.create({
  baseURL: config.apiUrl,
});

let clerkSession = null;

export const setClerkSession = (session) => {
  clerkSession = session;
};

// Keep backward compat
export const setClerkTokenGetter = (getter) => {};

axiosInstance.interceptors.request.use(
  async (requestConfig) => {
    if (clerkSession) {
      try {
        const token = await clerkSession.getToken();
        if (token) {
          requestConfig.headers.Authorization = `Bearer ${token}`;
        }
      } catch (err) {
        console.error('[axios] Failed to get token:', err);
      }
    }
    return requestConfig;
  },
  (error) => Promise.reject(error)
);

// Surface failures instead of failing silently: any failed write (POST/PATCH/
// PUT/DELETE) shows a toast with the server's message; a 401 shows a
// session-expired hint once. Failed GETs stay quiet (background polls would
// spam) — pages handle those themselves. Callers still get the rejection.
let lastAuthToast = 0;
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const method = (error?.config?.method || 'get').toLowerCase();
    if (error?.response?.status === 401) {
      if (Date.now() - lastAuthToast > 60000) {
        lastAuthToast = Date.now();
        notifyError('Your session expired — please sign in again.');
      }
    } else if (method !== 'get' && !error?.config?.silent) {
      notifyError(errorMessage(error));
    }
    return Promise.reject(error);
  },
);

// For fetch-based requests (e.g. SSE streams) that can't go through axios.
export const getAuthHeader = async () => {
  if (clerkSession) {
    try {
      const token = await clerkSession.getToken();
      if (token) return { Authorization: `Bearer ${token}` };
    } catch { /* ignore — dev-auth needs no header */ }
  }
  return {};
};

export default axiosInstance;
